import { Calendar, CalendarWrapper } from "@/components/calendar";
import { WEEK_DAY_GROUP } from "@/components/calendar/constants";
import { useModal, useNavigation } from "@/contexts";
import { MEDIA } from "@/styles/common";
import theme from "@/styles/theme";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Text } from "@chakra-ui/react";
import {
    HEADER_GROUP,
    useBookingRecoilValue,
    useCheckFakeValue,
    useCheckInValue,
    useCheckOutValue,
    useNewNavigate,
} from "@shared/client";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { CustomBox, CustomButton, CustomCenter, CustomSubText, CustomText, CustomWrapper } from "./dateSearchBar.style";
import { type DateSearchBarProps } from "./dateSearchBar.type";
import { useHandleData } from "./hooks";

export const DateSearchBar = ({ isSubMenu }: DateSearchBarProps) => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const checkFake = useCheckFakeValue();
    const diff = dayjs(checkOut).diff(dayjs(checkIn), "day");
    const { onNavigate } = useNewNavigate();
    const { openModal, setModalContent, setIconName } = useModal();
    const { navigation } = useNavigation();
    const { mutate } = useHandleData();
    const { pathname } = useLocation();
    const { isMobile } = MEDIA();
    const { idx, co_id } = getDefaultParameters();
    const bookingEngine = useBookingRecoilValue();

    const UPDATE_HEADER_GROUP = HEADER_GROUP.map((header) => ({
        ...header,
        subTitle: idx === "2017" && header.title === "About" ? "호텔소개" : header.subTitle,
        contents: header.contents.map((content) => ({
            ...content,
            title: idx === "2017" && content.title === "펜션소개" ? "호텔소개" : content.title,
        })),
    }));
    const handleWeekDay = (date: string) => {
        const weekDayName = WEEK_DAY_GROUP.find((week) => week.weekNum === dayjs(date).day())?.weekDay;
        return weekDayName;
    };

    const handleData = () => {
        if (pathname !== "/reserve") {
            onNavigate({ path: "/reserve" });
        }

        if (pathname === "/reserve") {
            mutate({ checkIn, checkOut: checkOut ?? checkFake });
        }
    };

    const onModal = () => {
        setModalContent(
            <CalendarWrapper>
                <Calendar onNavigate={onNavigate} />
            </CalendarWrapper>,
        );
        setIconName("close");
        openModal();
    };

    const { roomList, specialList } = navigation;
    const mobileColumnGap = isMobile ? "24px" : "60px";

    return (
        <CustomWrapper w="100%" isSubMenu={isSubMenu} bottom="0" h="120px">
            {(idx !== "2017" || co_id !== "suiteian") && (
                <CustomCenter className="date_search_bar_container" w="100%" h="100%" background="rgba(0,0,0,0.4)">
                    <Center
                        w="100%"
                        columnGap={pathname.includes("/reserve") ? "12px" : mobileColumnGap}
                        onClick={onModal}
                        cursor="pointer"
                    >
                        <Box textAlign="center">
                            <CustomText>Check-in</CustomText>
                            <Text>
                                {checkIn} ({handleWeekDay(checkIn)})
                            </Text>
                        </Box>
                        <Center textAlign="center" className="dayNight" w="48px" h="48px" p="0">
                            {checkOut ? diff : 1}박
                        </Center>
                        <Box textAlign="center">
                            <CustomText>Check-out</CustomText>
                            <Text>
                                {checkOut ?? checkFake} ({handleWeekDay(checkOut ?? checkFake)})
                            </Text>
                        </Box>
                    </Center>
                    <CustomBox className="date_search_bar_button_box">
                        <CustomButton size="medium" onClick={handleData}>
                            예약 조회
                        </CustomButton>
                    </CustomBox>
                </CustomCenter>
            )}

            {isSubMenu && (
                <Center className="sub_menu_container" background="white" w="60%" h="100%">
                    {UPDATE_HEADER_GROUP.map((header, index) => (
                        <Center
                            w="25%"
                            key={header.title}
                            flexDir="column"
                            rowGap="4px"
                            borderRight="1px dotted gray"
                            onClick={() => {
                                if (header.title === "Specials") {
                                    onNavigate({ path: `${header.contents[0].path}/${specialList[0].specialIdx}` });
                                }

                                if (header.title === "Rooms") {
                                    onNavigate({ path: `${header.contents[0].path}/${roomList[0].roomIdx}` });
                                }
                                if (header.title === "Reservation" && co_id === "suiteian")
                                    window.open(bookingEngine.bookingUrl);

                                if (header.title !== "Specials" && header.title !== "Rooms" && co_id !== "suiteian") {
                                    onNavigate({ path: header.contents[0].path });
                                }
                            }}
                            cursor="pointer"
                        >
                            <Text fontSize="14px" color={theme.COLOR.bgColor[200]}>
                                {(index + 1).toString().padStart(2, "0")}
                            </Text>
                            <CustomText>{header.title}</CustomText>
                            <CustomSubText>
                                {co_id === "suiteian" && header.title === "Reservation" ? "예약하기" : header.subTitle}
                            </CustomSubText>
                        </Center>
                    ))}
                </Center>
            )}
        </CustomWrapper>
    );
};
